const getTypicalJourneyStatusParamsFromCookies = (
  cookies: Record<string, unknown>
) => {
  const userSegment = cookies?.user_segment ?? "nonmember";

  const hasMembershipInBagCookieValue =
    cookies?.["bp-membership-in-bag"] ?? undefined;

  return {
    isMember: userSegment === "member",
    hasMembershipInBag: hasMembershipInBagCookieValue === "1"
  };
};

export const getTypicalJourneyStatus = (cookies: Record<string, unknown>) => {
  const { isMember, hasMembershipInBag } =
    getTypicalJourneyStatusParamsFromCookies(cookies);

  if (isMember || hasMembershipInBag) {
    return false;
  }

  return true;
};
